import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { isMobileUA } from 'dpl/shared/utils';
import { getMapBounds } from 'dpl/components/GoogleMap';
import MobileResults from 'dpl/shelter_search_results/components/MobileResults';
import Results from 'dpl/shelter_search_results/components/Results';

const isMobile = isMobileUA();

export default class ResultsPage extends Component {
  static propTypes = {
    closeShelter: PropTypes.func.isRequired,
    setQuery: PropTypes.func.isRequired,
    shelterId: PropTypes.number,
    showShelter: PropTypes.func.isRequired
  };

  static defaultProps = {
    shelterId: null
  };

  state = { mapIsLoaded: false };

  handleMapLoad = () => this.setState({ mapIsLoaded: true });

  handleMapUpdate = googleMap => {
    const { ne, sw } = getMapBounds(googleMap);

    this.props.setQuery({
      query: {
        bounding_box: {
          ne_corner: {
            latitude: ne.lat,
            longitude: ne.lng
          },
          sw_corner: {
            latitude: sw.lat,
            longitude: sw.lng
          }
        }
      }
    });
  };

  handleShelterClick = shelterId => {
    const {
      closeShelter,
      shelterId: activeShelterId,
      showShelter
    } = this.props;

    if (shelterId === activeShelterId) {
      closeShelter();
    } else {
      showShelter(shelterId);
    }
  };

  render() {
    const { closeShelter, shelterId, showShelter } = this.props;

    const { mapIsLoaded } = this.state;

    const props = {
      ...this.props,
      mapIsLoaded,
      onMapLoad: this.handleMapLoad,
      onMapUpdate: this.handleMapUpdate,
      onShelterClick: showShelter,
      onShelterClose: closeShelter,
      shelterId
    };

    return isMobile ? <MobileResults {...props} /> : <Results {...props} />;
  }
}
